import { useContext } from "react";
import { ActivitiesContext } from "../context/activities-context";

const GetLocation = (props) => {
	const { dictionaryWords } = useContext(ActivitiesContext);

	return (
		props.moreInfoCard.location && (
			<div className="info">
				<p className="title">{dictionaryWords.location}</p>
				<p>
					{props.moreInfoCard.location.name.nl &&
						props.moreInfoCard.location.name.nl}
				</p>
				{props.moreInfoCard.location.address.nl && (
					<>
						<p>
							{
								props.moreInfoCard.location.address.nl
									.streetAddress
							}
						</p>
						<p>
							{`${props.moreInfoCard.location.address.nl.postalCode} 
                        ${props.moreInfoCard.location.address.nl.addressLocality}`}
						</p>
					</>
				)}
			</div>
		)
	);
};

export default GetLocation;
